import * as React from 'react';
import './linkBar.scss';

export interface ILinkBar {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export class LinkBar extends React.Component<ILinkBar, {}> {
  public static defaultProps: Partial<ILinkBar> = {};

  public passDownProps = {
    style: this.props.style,
  };

  public render() {
    return (
      <div className="Table-nav navigation-bar" {...this.passDownProps}>
        {this.props.children}
      </div>
    );
  }
}
